require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./partenaires-actuels-du-sps-1-1-5-2.json") })
        }
      }, "path---partenaires-actuels-du-sps-1-1-5-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---partenaires-actuels-du-sps-1-1-5-2!./.cache/json/partenaires-actuels-du-sps-1-1-5-2.json
// module id = 514
// module chunks = 231608221292675